<template>
  <form-kit
    :type="buttonType"
    :classes="{ outer: ['w-auto!', btnCursorClass].join(' '), input: [$attrs.class, 'btn'].join(' ') }"
  >
    <span v-if="loading">{{ loadingText }}</span>
    <slot v-else />
  </form-kit>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({
  name: 'FormButton',
});

const props = defineProps({
  buttonType: {
    type: String,
    default: 'button',
    validator: (value) => ['button', 'submit'].includes(value),
  },
  loading: {
    type: Boolean,
    default: false,
  },
  loadingText: {
    type: String,
    default: 'Saving...',
  },
});

const btnCursorClass = computed(() => (props.loading ? 'cursor-progress' : ''));
</script>
